module.exports = __webpack_public_path__ + "static/media/46.ae701809.jpg";